var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgViewHistory({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C5.5 0 3.21875 1.375 2 3.46875V0.75C2 0.34375 1.65625 0 1.25 0C0.8125 0 0.5 0.34375 0.5 0.75V5.25C0.5 5.6875 0.8125 6 1.25 6H5.25C5.65625 6 6 5.6875 6 5.25C6 4.84375 5.65625 4.5 5.25 4.5H3.09375C4.03125 2.71875 5.90625 1.5 8 1.5C11.0312 1.5 13.5 3.96875 13.5 7C13.5 10.0312 11.0312 12.5 8 12.5C6.6875 12.5 5.4375 12.0312 4.46875 11.2188C4.15625 10.9375 3.6875 11 3.40625 11.3125C3.15625 11.625 3.1875 12.0938 3.5 12.375C4.75 13.4375 6.34375 14 8 14C11.8438 14 15 10.875 15 7C15 3.15625 11.8438 0 8 0ZM8 3C7.5625 3 7.25 3.34375 7.25 3.75V7.5C7.25 7.75 7.34375 8 7.5625 8.125L9.3125 9.375C9.4375 9.46875 9.59375 9.5 9.71875 9.5C9.9375 9.5 10.1562 9.40625 10.3125 9.1875C10.5625 8.875 10.4688 8.40625 10.1562 8.15625L8.75 7.125V3.75C8.75 3.34375 8.40625 3 8 3Z",
    fill: "#276EF1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewHistory);
export default __webpack_public_path__ + "static/media/view-history.1939a29e2c7faf7fb6dd88e06af8a438.svg";
export { ForwardRef as ReactComponent };